import { StoryToPlayFragment } from '@graphql/generated/graphql';
import { AdsOptions } from '@lib/config/featureConfig';
import { AdsPlacement } from '@lib/config/featureConfig/adsConfig';

import { StoryPageType } from '../enums';
import { SanitizedStoryPage } from '../types';
import { getMediaType } from './getMediaType';

type GetSanitizedStoryPagesOptions = {
    withTitle: boolean;
    muted: boolean;
    canUnmute: boolean;
};

export const getSanitizedStoryPages = (
    story: StoryToPlayFragment,
    options?: GetSanitizedStoryPagesOptions,
    ads?: AdsOptions
): SanitizedStoryPage[] => {
    const { withTitle = true, muted = true, canUnmute = true } = options ?? {};
    if (!story.StoryPages) return [];

    const pages: SanitizedStoryPage[] = [...story.StoryPages]
        .sort((a, b) => {
            if (typeof a.Order === 'number' && typeof b.Order === 'number') {
                return a.Order - b.Order;
            }

            return parseInt(a.id) - parseInt(b.id);
        })
        .map((page) => ({
            type: getMediaType(page.Media!) as
                | StoryPageType.Image
                | StoryPageType.Video,
            ...(withTitle && { title: story.Title }),
            subtitle: page.Title,
            media: page.Media!,
            looping: page.Looping ?? false,
            muted,
            canUnmute,
            text: page.DisplayText,
            ...(page.CallToAction?.length && { ctas: page.CallToAction }),
        }));

    if (ads && ads.vastUrl) {
        // @ts-expect-error - TODO: fix typing
        const adsPage: SanitizedStoryPage = {
            type: StoryPageType.Ads,
            ads: {
                vastUrl: ads.vastUrl,
                debug: ads.debug,
                ...(ads.ctaText && { vastCtaText: ads.ctaText }),
                ...(ads.timeout !== undefined && { timeout: ads.timeout }),
            },
        };
        switch (ads.placement) {
            case AdsPlacement.PreRoll:
                pages.unshift(adsPage);
                break;
            case AdsPlacement.MidRoll:
                const index = Math.floor(story.StoryPages.length / 2);
                pages.splice(index, 0, adsPage);
                break;
            case AdsPlacement.PostRoll:
                pages.push(adsPage);
                break;
        }
    }

    return pages;
};
